const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  systemType: state => state.systems.systemType,
  isSafing: state => state.systems.isSafing,
  systemId: state => state.systems.systemId,
  shellId: state => state.systems.shellId,
  userId: state => state.systems.userId,
  cooperationType: state => state.systems.cooperationType,
  authorization: state => state.user.authorization,
  getLoginAuthForm: state => state.auth.loginAuthForm,
  getPageType: state => state.systems.pageType,
  getPageCode: state => state.systems.pageCode,
  payNum: state => state.systems.payNum
}
export default getters
